import styled from '@emotion/styled';
import { pxToRem, pxTovW } from '@geneo2-web/shared-ui';
import {
  Step,
  StepConnector,
  stepConnectorClasses,
  StepLabel,
  Stepper,
  Typography,
} from '@mui/material';
import { Box, display } from '@mui/system';
import React from 'react';

export interface ISteps {
  index: number;
  stepTitle: string;
  stepClickHandler: () => void;
  nextClickHandler?: () => void;
  stepButtonText?: string;
  disableStep: boolean;
  stepIconColor: string;
  disabledIconColor?: string;
}
interface IProps {
  steps: ISteps[];
  currentStep: number;
}

const CustomConnector = ({ style }: { style?: React.CSSProperties }) => (
  <Box
    sx={{
      flex: 1,
      height: { xs: pxToRem(5), md: pxTovW(5) },
      background: style?.background || '#B8E0FF',
      alignSelf: 'center',
      borderRadius: '2px',
      marginX: 0,
      zIndex: 1, // lower zIndex for connector
      marginLeft: { xs: `-${pxToRem(10)}`, md: `-${pxTovW(14)}` },
      marginRight: { xs: `-${pxToRem(10)}`, md: `-${pxTovW(14)}` },
    }}
  />
);

export const StepperComponent = (props: IProps) => {
  const { steps, currentStep } = props;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center', // center vertically
        width: '100%',
        maxWidth: { xs: pxToRem(250), md: pxTovW(419) },
      }}
    >
      {steps.map((step, i) => (
        <React.Fragment key={i}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 2, // higher zIndex for icon and label
              position: 'relative',
              minWidth: 0, // allow shrinking
            }}
          >
            <Step
              sx={{ padding: 0, margin: 0 }}
              onClick={() => {
                if (!step.disableStep) {
                  step.stepClickHandler();
                }
              }}
            >
              <StepLabel
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: 0,
                  margin: 0,
                }}
                StepIconComponent={() => (
                  <Box
                    sx={{
                      position: 'relative',
                      width: { xs: pxToRem(20), md: pxTovW(29) },
                      height: { xs: pxToRem(20), md: pxTovW(29) },
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: step.disableStep
                        ? step.disabledIconColor
                        : step.stepIconColor,
                      boxShadow: '0px 0px 0.573vw rgba(231, 231, 231, 0.85)',
                      cursor: 'pointer',
                      zIndex: 2, // icon above connector
                    }}
                  >
                    <Box
                      sx={{
                        width: { xs: pxToRem(10), md: pxTovW(15) },
                        height: { xs: pxToRem(10), md: pxTovW(15) },
                        borderRadius: '50%',
                        backgroundColor: '#fff',
                      }}
                    />
                  </Box>
                )}
              />
            </Step>
            {/* Step text below icon, absolutely positioned, does not affect width */}
            <Typography
              variant="caption"
              sx={{
                position: 'absolute',
                top: { xs: pxToRem(26), md: pxTovW(34) }, // just below the icon
                left: '50%',
                transform: 'translateX(-50%)',
                whiteSpace: 'nowrap',
                color: '#333333',
                zIndex: 3, // above connector
                pointerEvents: 'none',
                fontSize: { xs: pxToRem(10), md: pxTovW(12) },
                fontWeight: 'bold',
              }}
            >
              {step.stepTitle}
            </Typography>
          </Box>
          {i < steps.length - 1 && (
            <CustomConnector
              style={{
                background: i < currentStep ? '#007CDC' : '#B8E0FF',
              }}
            />
          )}
        </React.Fragment>
      ))}
    </Box>
  );
};
// ...existing code...
// ...existing code...
// import React, { useState } from 'react';

// import { Box, Button, Paper, Typography } from '@mui/material';
// import Check from '@mui/icons-material/Check';
// export const StepperComponent = () => {
//   const [currentStep, setCurrentStep] = useState(0);
//   const totalSteps = 2;

//   const handleStepClick = (stepIndex: number) => {
//     if (stepIndex <= currentStep + 1) {
//       setCurrentStep(stepIndex);
//     }
//   };

//   const StepCircle = ({
//     index,
//     isCompleted,
//     isActive,
//   }: {
//     index: number;
//     isCompleted: boolean;
//     isActive: boolean;
//   }) => (
//     <Box
//       role="button"
//       tabIndex={0}
//       onClick={() => handleStepClick(index)}
//       onKeyDown={(e) => e.key === 'Enter' && handleStepClick(index)}
//       sx={{
//         width: 48,
//         height: 48,
//         borderRadius: '50%',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         cursor: 'pointer',
//         transition: 'all 0.3s ease',
//         position: 'relative',
//         bgcolor: isCompleted
//           ? 'primary.main'
//           : isActive
//           ? 'primary.light'
//           : 'grey.300',
//         boxShadow: 3,
//         '&:hover': {
//           transform: 'scale(1.1)',
//         },
//       }}
//       aria-label={`Step ${index + 1} ${
//         isCompleted ? 'completed' : isActive ? 'current' : 'pending'
//       }`}
//     >
//       {isCompleted ? (
//         <Check style={{ color: 'white', fontSize: 20 }} />
//       ) : (
//         <Typography
//           variant="body1"
//           sx={{ color: isCompleted || isActive ? 'white' : 'grey.700' }}
//         >
//           {index + 1}
//         </Typography>
//       )}
//       <Typography
//         variant="caption"
//         sx={{ position: 'absolute', bottom: -24, color: 'grey.600' }}
//       >
//         Step {index + 1}
//       </Typography>
//     </Box>
//   );

//   const StepConnector = ({
//     isCompleted,
//     isPartial,
//   }: {
//     isCompleted: boolean;
//     isPartial: boolean;
//   }) => (
//     <Box
//       sx={{
//         position: 'relative',
//         width: 96,
//         height: 8,
//         mx: 1,
//       }}
//     >
//       <Box
//         sx={{
//           position: 'absolute',
//           inset: 0,
//           bgcolor: 'grey.300',
//           borderRadius: 4,
//         }}
//       />
//       <Box
//         sx={{
//           position: 'absolute',
//           inset: 0,
//           bgcolor: 'primary.main',
//           width: isCompleted ? '100%' : isPartial ? '50%' : '0%',
//           borderRadius: 4,
//           transition: 'width 0.3s ease',
//         }}
//       />
//     </Box>
//   );

//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//       }}
//     >
//       {Array.from({ length: totalSteps }).map((_, index) => (
//         <React.Fragment key={index}>
//           <StepCircle
//             index={index}
//             isCompleted={index < currentStep}
//             isActive={index === currentStep}
//           />
//           {index < totalSteps - 1 && (
//             <StepConnector
//               isCompleted={index < currentStep - 1}
//               isPartial={index === currentStep - 1}
//             />
//           )}
//         </React.Fragment>
//       ))}
//     </Box>
//   );
// };
